<template>
    <div>
        <form class="create-account-form" @submit.prevent="createAccount">
            <div class="form-group mb-0 mt-5" :class="{'is-invalid': underValidation && !password}">
                <label for="email" class="sr-only">Email</label>
                <input ref="email" type="email" class="form-control" :class="{'is-invalid': underValidation && !email}" v-model="email" placeholder="Email Address" autocomplete="new-password" required>
            </div>
            <div class="form-group mb-0" :class="{'input-group': password, 'is-invalid': underValidation && !password}">
                <label for="password" class="sr-only">Password</label>
                <b-input-group>
                <input ref="password" :type="passwordInputType" class="form-control" :class="{'is-invalid': underValidation && !password}" v-model="password" placeholder="Password" autocomplete="new-password" required>
                <input ref="password_confirmation" :type="passwordInputType" class="form-control" :class="{'is-invalid': underValidation && !password && !matching}" v-model="passwordConfirmation" placeholder="Password Confirmation" autocomplete="new-password" required @input="checkMatching">

                    <template #append>
                        <b-btn type="button" variant="light" class="border" :class="{'active': showPassword}" @click="togglePasswordVisibility">
                            <span v-if="showPassword">
                                <font-awesome-icon :icon="['fad', 'eye-slash']" fixed-width />
                            </span>
                            <span v-else>
                                <font-awesome-icon :icon="['fad', 'eye']" fixed-width />
                            </span>
                        </b-btn>
                    </template>
                </b-input-group>
            </div>
            <button type="submit" class="btn btn-lg btn-success w-100 mt-2" @click.prevent="createAccount">
                Create Account
            </button>
            <br/>
            <br/>
            <!-- TODO: reCaptcha -->
        </form>
    </div>
</template>

<script>
import { mapState } from 'vuex'

import states from '@/common/states'

import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'

import LoginForm from '@/components/LoginForm'

export default {
    name: "RegisterForm",
    props: {
        redirect: {
            type: String,
            default: "/checkout"
        }
    },
    data: () => ({
        email: null,
        password: null,
        passwordConfirmation: null,
        underValidation: false,

        matching: false,
        showPassword: false
    }),
    components: {
        Navbar,
        Footer,

        LoginForm
    },
    computed: mapState({
        passwordInputType () {
            if (this.showPassword) { return 'text' }
            else { return 'password' }
        },
        credentials: state => state.checkout.credentials
    }),
    methods: {
        checkMatching() {
            this.matching = this.passwordConfirmation == this.password;
        },
        createAccount () {
            if (!this.validateCreateAccount()) { return false }
            //
            let authRedirect = null
            let queryRedirect = null

            if (this.$auth.redirect()) {
                authRedirect = this.$auth.redirect()
            }
            if (this.$route.query && this.$route.query.redirect) {
                queryRedirect = this.$route.query.redirect
            }
            this.$auth.register({
                url: 'auth/register',
                data: {username: this.email, password: this.password, password_confirmation: this.passwordConfirmation, state: null},
                autoLogin: true,
                fetchUser: true,
                redirect: {
                    path: authRedirect ? authRedirect.from.fullPath : queryRedirect
                },
                success: (response) => {
                    this.underValidation = false;
                    this.$router.push(this.redirect);
                },
                error: (error) => {
                    this.underValidation = false;
                    this.$swal({
                        toast: true,
                        html: error.response.data.error || error.response.data.message,
                        type: 'error',
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 5000
                    })
                }
            });
        },
        validateCreateAccount () {
            this.underValidation = true

            var valid = true

            if (!this.email) {
                valid = false
                this.$refs.email.focus()
            }

            else if (!this.password) {
                valid = false
                this.$refs.password.focus()
            }

            else if (!this.passwordConfirmation) {
                valid = false
                this.$refs.password_confirmation.focus()
            }

            else if (this.password !== this.passwordConfirmation) {
                // Passwords do not match
                valid = false
                this.matching = false
                this.$swal({
                    toast: true,
                    html: "Passwords do not match",
                    type: 'error',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 5000
                })
                this.$refs.password_confirmation.focus()
                return;

            } else {
                this.matching = true
            }

            if (!valid) {
                let message = null

                if (!this.email && !this.password) {
                    message = "Please enter an email address and password"
                } else if (!this.email && this.password) {
                    message = "Please enter an email address"
                } else if (this.email && !this.password) {
                    message = "Please enter a password"
                }

                this.$swal({
                    toast: true,
                    html: message,
                    type: 'error',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 5000
                })
            }

            return valid
        },
        togglePasswordVisibility () {
            this.showPassword = !this.showPassword
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/_colors.scss";

    .login-form .checkbox {
        font-weight: 400;
    }
    .login-form .form-control {
        position: relative;
        box-sizing: border-box;
        height: auto;
        padding: 10px;
        font-size: 16px;
    }
    .login-form .form-control:focus {
        z-index: 2;
    }
    .login-form input[type="email"] {
        margin-bottom: -1px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }
    .login-form input[type="password"] {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    .checkbox {
        font-weight: 400;
    }

    .form-control {
        position: relative;
        box-sizing: border-box;
        height: auto;
        padding: 10px;
        font-size: 16px;
    &:focus {
         z-index: 3;
     }
    }

    .input-group > .form-control:not(:first-child),
    .input-group > .custom-select:not(:first-child) {
        border-bottom-left-radius: 4px;
    }

    .input-group .btn {
        border-top-right-radius: 0;
    }

    input[type="email"] {
        margin-bottom: -1px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }

    input[type="password"] {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    input.is-invalid {
        z-index: 5;
    }
</style>